import 'react-loading-skeleton/dist/skeleton.css';
import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

import { HomeContentEntity } from '../../domain/entities/HomeContentEntity';

import styles from '../styles/HomeBannerWrapper.module.scss';

import HomeBannerImageCmp from './HomeBannerImageCmp';
import HomeBannerTextCmp from './HomeBannerTextCmp';
import HomeBannerTextCmpV2 from './HomeBannerTextCmpV2';

interface HomeBannerWrapperCmpProps {
  data: HomeContentEntity;
  is_enterprise_v2_enabled?: boolean;
  is_loading?: boolean;
}

function HomeBannerWrapperCmp({
  data,
  is_enterprise_v2_enabled = false,
  is_loading = false,
}: HomeBannerWrapperCmpProps): React.ReactElement {
  const wrapperClassName = `${styles['banner-wrapper']} ${
    is_enterprise_v2_enabled ? styles['enterprise-v2'] : ''
  }`;

  return (
    <div className={wrapperClassName}>
      <HomeBannerImageCmp
        desktopBanner={data.banner.banner_image.path}
        mobileBanner={data.banner.banner_img_mobile.path}
      />
      <div className={styles['banner-overlay']} />
      <div className={styles['desktop-only']}>
        <HomeBannerTextCmp
          title={data.banner.banner_text}
          description={data.banner.banner_subtext}
        />
      </div>
      <div className={styles['mobile-only']}>
        {is_loading ? (
          <SkeletonTheme
            baseColor="#e6e6e6"
            duration={2.0}
            highlightColor="#FEFEFE"
          >
            <Skeleton
              height="16rem"
              containerClassName={styles['skeleton-1']}
            />
          </SkeletonTheme>
        ) : is_enterprise_v2_enabled ? (
          <HomeBannerTextCmpV2
            title={data.banner.banner_text}
            description={data.banner.banner_subtext}
          />
        ) : (
          <HomeBannerTextCmp
            title={data.banner.banner_text}
            description={data.banner.banner_subtext}
          />
        )}
      </div>
    </div>
  );
}

export default HomeBannerWrapperCmp;
